import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy'>
    <div className=" privacy-policyHeight container py-3">
      <h1>VIZZHY Privacy Policy</h1>

      <section>
        <h4>Introduction</h4>
        <p>
          VIZZHY INC. OR VARDHAN SK HEALTHCARE PRIVATE LIMITED
        </p>
        <p>
          This “Privacy Policy” explains how we collect, use, share, disclose, and protect Personal Information about the users of the services including the Practitioners (as defined in the Terms of Use, which may be accessed via the following weblink <a href="https://vizzhy.com/TermsConditions" target="_blank">https://vizzhy.com/TermsConditions</a> the Terms of Use), the End-Users (as defined in the Terms of Use), and the visitors of Website (jointly and severally referred to as “you” or “users” in this Privacy Policy). We created this Privacy Policy to demonstrate our commitment to the protection of your privacy and your personal information. Your use of and access to the Services is subject to this Privacy Policy and our Terms of Use. Any capitalized term used but no defined in this Privacy Policy shall have the meaning attributed to it in our Terms of Use.
        </p>
        <p>
          BY USING THE SERVICES OR BY OTHERWISE GIVING US YOUR INFORMATION, YOU WILL BE DEEMED TO HAVE READ, UNDERSTOOD AND AGREED TO THE PRACTICES AND POLICIES OUTLINED IN THIS PRIVACY POLICY AND AGREE TO BE BOUND BY THE PRIVACY POLICY. YOU HEREBY CONSENT TO OUR COLLECTION, USE AND SHARING, DISCLOSURE OF YOUR INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY. WE RESERVE THE RIGHT TO CHANGE, MODIFY, ADD OR DELETE PORTIONS OF THE TERMS OF THIS PRIVACY POLICY, AT OUR SOLE DISCRETION, AT ANY TIME. IF YOU DO NOT AGREE WITH THIS PRIVACY POLICY AT ANY TIME, DO NOT USE ANY OF THE SERVICES OR GIVE US ANY OF YOUR INFORMATION.
        </p>
        <p>
          IF YOU USE THE SERVICES ON BEHALF OF SOMEONE ELSE (SUCH AS YOUR CHILD) OR AN ENTITY (SUCH AS YOUR EMPLOYER), YOU REPRESENT THAT YOU ARE AUTHORISED BY SUCH INDIVIDUAL OR ENTITY TO (I) ACCEPT THIS PRIVACY POLICY ON SUCH INDIVIDUAL’S OR ENTITY’S BEHALF, AND (II) CONSENT ON BEHALF OF SUCH INDIVIDUAL OR ENTITY TO OUR COLLECTION, USE AND DISCLOSURE OF SUCH INDIVIDUAL’S OR ENTITY’S INFORMATION AS DESCRIBED IN THIS PRIVACY POLICY.
        </p>
      </section>

      <section>
        <h4>Reason for Privacy Policy</h4>
        <p>This Privacy Policy is published in compliance with each country’s Information Technology Act and Policies of Healthcare.</p>
        <p>TO INCLUDE THE SECTIONS AND REGULATIONS OF RESPECTIVE COUNTRIES HERE</p>
      </section>

      <section>
        <h4>1. Data Collection</h4>
        <p>Personal Data: Name, gender, date of birth, address, email, phone number, payment details (for subscriptions).</p>
        <p>Usage Data: App activity, device information, IP address, cookies.</p>
        <p>Health Data: Mood tracking, medication history, any previous chronic or acute diseases if treatment is availed from a practitioner (if provided by the user).</p>
        <p>Insurance Data: Health Insurance carrier and insurance plan.</p>
        <p>Financial Data: For payment details (credit/debit cards, bank accounts).</p>
      </section>

      <section>
        <h4>2. How Data is Used</h4>
        <ul>
          <li>Providing and improving services.</li>
          <li>Personalizing user experience.</li>
          <li>Marketing and promotional communication (users can opt out).</li>
          <li>Research and analysis.</li>
          <li>Complying with legal obligations.</li>
          <li>Sending promotional offers and feedback requests.</li>
        </ul>
      </section>

      <section>
        <h4>3. Data Sharing</h4>
        <ul>
          <li>With third-party service providers for payment processing, analytics, and advertising.</li>
          <li>Practitioners for appointment booking and treatment purposes.</li>
          <li>With legal authorities when required by law.</li>
          <li>Anonymous data may be shared for research purposes.</li>
          <li>Data may be transferred during business reorganizations.</li>
        </ul>
      </section>

      <section>
        <h4>4. User Rights and Choices</h4>
        <ul>
          <li>Access, update, or delete personal data.</li>
          <li>Opt-out of marketing communications.</li>
          <li>Disable cookies through browser settings.</li>
        </ul>
      </section>

      <section>
        <h4>5. Data Security</h4>
        <p>Uses encryption and security measures to protect user data. No guarantee of absolute security in internet-based data transmission.</p>
      </section>

      <section>
        <h4>6. Children’s Privacy</h4>
        <p>Not intended for children under 13 (or relevant age based on jurisdiction). Parental consent required for minors where applicable.</p>
      </section>

      <section>
        <h4>7. International Data Transfers</h4>
        <p>Data may be transferred and stored in different countries. Compliance with applicable laws for data protection.</p>
      </section>

      <section>
        <h4>8. Third-Party Transfers and Disclosures</h4>
        <p>Include a section for Third-Party Transfers and Disclosures.</p>
        <p>List of companies we share data with.</p>
      </section>

      <section>
        <h4>9. Policy Updates</h4>
        <p>Vizzhy may update the privacy policy periodically. Users will be notified of significant changes.</p>
      </section>

      <section>
        <h4>10. Contact Information</h4>
        <p>Users can contact Vizzhy for privacy-related concerns via email or customer support.</p>
        <p>Enter here office business address, email address, phone number.</p>
      </section>

      <section>
        <h4>11. Communication Retention</h4>
        <p>If you choose to communicate with Vizzhy through text, email, secure messaging, or eCare Services, the content of your messages and communications (including video content) will be stored along with your contact information (such as email addresses). Responses from Vizzhy will also be retained for record-keeping purposes.</p>
      </section>

    </div>
    </div>
  );
};

export default PrivacyPolicy;
